"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDateWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var moment = require("moment");
var DateInput_1 = require("../components/DateInput");
var journey_services_1 = require("@athena-portal/journey-services");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var luxon_1 = require("luxon");
var now = luxon_1.Settings.now;
var CustomDateWidget = /** @class */ (function (_super) {
    __extends(CustomDateWidget, _super);
    function CustomDateWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setInteractionDate = function (date) {
            var dateMoment = moment.utc(date);
            var dateArr = date.split("-");
            _this.setState({
                dateDay: dateArr[2],
                dateMonth: dateArr[1],
                dateYear: dateArr[0],
                date: dateMoment
            }, _this.bindToField);
        };
        _this.bindToField = _this.bindToField.bind(_this);
        _this.handleOnBlurEvent = _this.handleOnBlurEvent.bind(_this);
        _this.getDateValue = _this.getDateValue.bind(_this);
        _this.inputDisabled = _this.getSetting("inputDisabled", undefined);
        _this.showDateNow = _this.getSetting("showDateNow", false);
        _this.subTextDisabled = _this.getSetting("subTextDisabled", true);
        _this.subText = _this.getSetting("subText", undefined);
        _this.dayText = _this.getSetting("dayText", undefined);
        _this.monthText = _this.getSetting("monthText", undefined);
        _this.yearText = _this.getSetting("yearText", undefined);
        _this.defaultToPolicyStart = _this.getSetting("defaultToPolicyStart", undefined);
        var date;
        if (_this.showDateNow) {
            date = moment.utc(now());
        }
        else {
            date = _this.defaultToPolicyStart && _this.props.interaction.uistate && _this.props.interaction.uistate.previousVersionStartDate ?
                _this.props.interaction.uistate.previousVersionStartDate :
                journey_services_1.ObjectManipulator.fetchFieldValue(_this.props.question.interactionField, _this.props.interaction);
        }
        if (date) {
            var dateMoment = moment.utc(date, moment.ISO_8601);
            if (_this.defaultToPolicyStart) {
                dateMoment = dateMoment.isBefore(moment.utc()) ? moment.utc() : dateMoment;
            }
            _this.state = {
                dateDay: dateMoment.format("DD"),
                dateMonth: dateMoment.format("MM"),
                dateYear: dateMoment.format("YYYY"),
                date: dateMoment,
                isChanged: _this.props.interaction.isChanged ? _this.props.interaction.isChanged : false,
            };
        }
        else {
            _this.state = {
                dateDay: '',
                dateMonth: '',
                dateYear: '',
                date: undefined,
                isChanged: false,
            };
        }
        return _this;
    }
    CustomDateWidget.prototype.componentDidMount = function () {
        if (this.state.date) {
            this.bindToField();
        }
    };
    CustomDateWidget.prototype.renderInputField = function () {
        return ((0, jsx_runtime_1.jsx)(DateInput_1.DateInput, { fieldName: this.props.question.name, subTextDisabled: this.subTextDisabled, isReadOnly: this.isReadOnly(), isDisabled: this.inputDisabled, dayText: this.dayText, monthText: this.monthText, yearText: this.yearText, setParentState: this.setInteractionDate, dateDay: this.state.dateDay, dateMonth: this.state.dateMonth, dateYear: this.state.dateYear, labelText: this.props.question.label, changed: this.props.interaction.isChanged, executeNativeEvent: this.executeNativeEvent }));
    };
    CustomDateWidget.prototype.bindToField = function () {
        var customDate = this.getDateValue();
        var valueAsMoment = moment.utc(customDate, moment.ISO_8601).utc(true).startOf("day");
        if (parseInt(this.state.dateYear) < 1943) {
            // Because before 1943 we get a random X amount of hour for no apparent reason (some isues with moment.js)
            // Adding this hours do not affect actual value of field, it jut affects how validation works.
            valueAsMoment.add(11, "hours");
        }
        // If date is valid, set it to interaction, otherwise reset value in interaction
        this.props.onStateChange(this.props.question.interactionField, valueAsMoment.isValid() ? valueAsMoment.format() : undefined);
        this.validateInternal(customDate !== "--" ? valueAsMoment : undefined);
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    CustomDateWidget.prototype.getDateValue = function () {
        return "".concat(this.state.dateYear, "-").concat(this.state.dateMonth, "-").concat(this.state.dateDay);
    };
    return CustomDateWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.CustomDateWidget = CustomDateWidget;
//# sourceMappingURL=CustomDateWidget.js.map